import React from 'react'
import { connect } from 'react-redux'
import { selectors } from '../../../main/user/reducer'
import { RenderedHtml } from 'components'

const TicketActivityInfoCard = ({
  id,
  activityImage,
  caption,
  name,
}) => {

  const backgroundImage = `url(${activityImage})`
  const ariaDescriptionId = `product-description-${id}`

  return (
    <div
      className='w-full font-roboto'
    >
      <section
        className='flex flex-col relative w-full h-full bg-white'
      >
        <figure
          className='relative h-72 flex items-end justify-center p-5 bg-cover bg-center'

          style={{ backgroundImage }}
        >
        </figure>

        <section
          className='flex flex-col flex-1 gap-4 p-5 items-center' 
        >
          <header
            className='space-y-2 text-center'
          >
            <h2 className="mb-0 text-2xl">{name}</h2>
          </header>
          <div className="w-full m-0" id={ariaDescriptionId}>
            <RenderedHtml>{caption}</RenderedHtml>
          </div>
        </section>
      </section>
    </div>
  )
}

function mapStateToProps(state) {
  return { isAuthenticated: selectors.isAuthenticated(state) }
}

export default connect(mapStateToProps)(TicketActivityInfoCard)
